import type { FaireProductEntity } from "../../entity_types/product";

export const p_jb455zfqe2: FaireProductEntity = {
  token: "p_jb455zfqe2",
  type: "product",
  name: "Aquamarine Opal Ring Set in 18K White Gold",
  brandToken: "b_3u7f7kz1",
  brandName: "Golden NYC Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/5db753558a8442a0057ad785c78bd4cfac97251f23ae3d13d313b2f395bb6894.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c47c35a27ff0fc06df2922f36be825f6de13b34d82b220a819f1b31bddf2c14d.jpeg",
    "https://cdn.faire.com/fastly/2fc9222b52ff4580ce93d5e9f7bb0b4c2f09ce6af24ce5e60b8d02ac2f9ff864.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Made with 18k white gold plated brass\nOpal and aquamarine cubic zirconia stones\nHalo Design\n4.00 CTTW\nAvailable in sizes 6, 7, 8 and 9\nMetal type: Brass\nWeight (lbs.): 0.01",
  tags: [],
  msrpDollars: 41.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:45.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
